import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Scaffold } from "../Scaffold";
import { Button, Typography } from "@mui/material";
import { State } from "../redux/types";
import { useAuth } from "../AuthContext";
import { setResult, setAdvanceResult, setSelect, setRsAdminResult } from "../redux/actions";


export const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { role } = useAuth();
  const setLogin = useSelector((state: State) => state.login);
  const handleChange = () => {
    dispatch(setResult(null));
    dispatch(setAdvanceResult(null));
    dispatch(setSelect(null));
    dispatch(setRsAdminResult(null));
    navigate("/dashboardrsadmin");
  };

  return (
    <Scaffold navBar>
      <Typography variant="h4">Welcome {setLogin.firstName},</Typography>
      {role === "medley-admin-group" && (
        <Button
          color="primary"
          variant="text"
          onClick={handleChange}
        >
          Switch to RS Admin
        </Button>
      )}
    </Scaffold>
  );
};
